import React, { useEffect, useContext, useState, useCallback } from 'react';
import _ from 'lodash';
//import { renderContentFromMetadata } from '@jutro/uiconfig'
import { MetadataContent } from '@jutro/uiconfig';

import { withRouter } from 'react-router-dom';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useAuthentication} from 'gw-digital-auth-react';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import styles from './RIBillingDeliveryComponent.module.scss';
import metadata from './RIBillingDeliveryComponent.metadata.json5';
import messages from './RIBillingDeliveryComponent.messages';
import { Loader } from '@jutro/components';
import { BillingService } from 'gw-capability-billing';

import { getToggleButtonObj, 
         setToggleButtonClassName, 
         buildEmailArray, 
         getCheckButton,
         focusOnInputEmailField,
         arraysEqual,
         clickCheckButton,
         removeBlankEmail,
         addPenEventListener,
         setCheckCloseButtonClassName,
         getCloseButton,
         clickLastTrashButton } from '../../utils/RIBillingDeliveryUtil'

// jz -----------------------------------
const getEmailAddressData = (billingDelivery) => {
    const emailAddress = billingDelivery.emailAddress;
    const emailList = [];
    for (let index = 0; index < emailAddress.length; index++) {
        emailList.push({'email': emailAddress[index]});
    }

    return emailList;    
};

const getBillingDeliveryData = () =>{
    return {
        "billingAccount": "700539650",
        "mailReference": "Email",
        "emailAddress": [
            "c.mize@gokiefer.com",
            "billing@ri-net.com",
            "riaudit@ri-net.com"
        ],
        "addedEmailAddress": null,
        "removedEmailAddress": null
    }
};
// ----------------------------------- jz

function RIBillingDeliveryComponent() {
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();      
    const [pageError, setPageError] = useState({}); 
    // jz ------------------------------------------------------------------
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(false);
    const [billingDelivery, setBillingDelivery] = useState();
    const [isAddingEmail, setIsAddingEmail] = useState(false);    
    const [emailData, setEmailData] = useState([]);
    const [saveEmailData, setSaveEmailData] = useState({});    
    const [isEmail, setIsEmail] = useState(true);
    const [saveIsEmail, setSaveIsEmail] = useState(true);
    const [toggleButton, setToggleButton] = useState({});                                  
    // ------------------------------------------------------------------ jz

    useEffect(() => {
        getBillingDelivery();        
    }, []);    

    useEffect(() => {
        setToggleButtonClassName(toggleButton,isEmail);
    },[saveEmailData, isEmail, isEditing]);

    const getBillingDelivery = () => {
        BillingService.getBillingDelivery_RI( authHeader ).then(
            (response = {}) => {
                if (!_.isUndefined(response)) {                      
                    setInitialData(response);        
                } 
            }).catch((err) => {
                switch (err.error) {
                    case 'Error with service':                            
                        setPageError('error');            
                        break;                        
                }
            }).finally(() => {
                setIsLoading(false);               
            });    
    };

    const setInitialData = (response) => {
        setIsLoading(false);  
        setToggleButton(() => getToggleButtonObj());
        setBillingDelivery(response);
        setEmailData(() => getEmailAddressData(response));
        setSaveEmailData(() => getEmailAddressData(response));
        setIsEmail(() => response.mailReference === 'Email');
        setSaveIsEmail(() => response.mailReference === 'Email');
    };    

    const deleteDataRow = useCallback(
        (row, index) => {
            const newData = [...emailData];
            newData.splice(index, 1);
            setEmailData(newData);
        },
        [emailData]
    );

    // called after enter the email.
    const saveDataRow = useCallback(
        (newRow, index) => {  

            removeBlankEmail(emailData);
            if(newRow.email !== ''){
                const newData = [...emailData];
                newData.splice(index, 1, newRow);
                setEmailData( newData );
                setTimeout( addPenEventListener, 200 );
            }  
        },
        [emailData]
    );
    
    // When click +Add  button, append a new 
    // row and put the focus on the input field.
    const addDataRow = useCallback(() => {
        setIsAddingEmail(true);  
        const newData = [...emailData];
        newData.push({'email':''});
        setEmailData( newData );  

        // Wait 200 milliseconds, then open the input field.
        setTimeout( clickPenActionitem, 200 );              
    },[emailData]);   

    const enterEditMode = () => {
        setIsEditing(true);
        setIsAddingEmail(false);
        setPageError({});
        setTimeout( addPenEventListener, 200 );
    };

    const handleCancel = () => {
        setIsEditing(false);
        setIsAddingEmail(false);
        clickCheckButton();
        removeBlankEmail(emailData);
        setPageError({});
        setEmailData(saveEmailData);
        setIsEmail(saveIsEmail);
    };

    const onClickToggleChange = useCallback((value) => {   
        setIsEmail(value);
    }, []);

    const readValue = useCallback(
        (id, path) => {                       
            return _.get(emailData, path);;
        } , [emailData]
    );

    // Click the pen to open the input field.
    const clickPenActionitem = () => {
        const penIcons = document.querySelectorAll('.fa-pen');
        for (let index = penIcons.length - 1 ; index >= 0; index--) {
            const penIcon = penIcons[index];
            penIcon.closest('button').click();
            setCheckButtonEvent();
            setTimeout( focusOnInputEmailField, 500 );   
            setCheckCloseButtonClassName();
            break;
        }
    };

    const setCheckButtonEvent = () => {    
        
        const checkButton = getCheckButton();
        if(checkButton != null){
            checkButton.addEventListener('click',afterAddNewEamilAddress);
        }
        const closeButton = getCloseButton();
        if(closeButton != null){
            closeButton.addEventListener('click',cancelAddNewEamilAddress);
        }     
    };

    const afterAddNewEamilAddress = (e) => {       
        setIsAddingEmail(false);
    };

    const cancelAddNewEamilAddress = (e) => {    
        setTimeout(clickLastTrashButton, 100);
        setIsAddingEmail(false);
    };

    // Set the final object for the updating ----------------
    const setFinalObj = () => {   
        let removedEmail = [];
        let addedEmail = [];
        
        if(isEmail) {
            removeBlankEmail(emailData);
            removedEmail = setRemovedEmail();
            addedEmail = setAddedEmail();
        }     

        const finalObj = 
        {
            "billingAccount": billingDelivery.billingAccount,
            "mailReference": isEmail ? "Email" : "Mail",
            "emailAddress": null,
            "addedEmailAddress": addedEmail,
            "removedEmailAddress": removedEmail
        }
        return finalObj;
    };
    const setAddedEmail = () => {
        return buildEmailArray([...emailData],saveEmailData);;
    };
    const setRemovedEmail = () => {       
        return buildEmailArray([...saveEmailData], emailData);;
    };
    // ----------------Set the final object for the updating

    const hasChanges = () => {        
        // debugger;
        if(saveIsEmail === isEmail && arraysEqual(emailData, saveEmailData)){
            return false;
        }
        return true;
    };

    const handleSubmit = useCallback(
        
        (evt) => {

            if (evt) {
                evt.preventDefault();
            }

            clickCheckButton();                
            setIsEditing(false);

            if(hasChanges()) {
                if(isEmail === true && emailData.length === 0){
                    setPageError('mustHaveEmail');
                    setIsEditing(true);
                    return Promise.resolve();
                }                
                setPageError('updating');   
                setIsUpdating(true);
                const billinDelivery = setFinalObj();                

                BillingService.updsateBillingDelivery_RI(billinDelivery, authHeader)
                .then((data) =>{
                    setPageError('updated');   
                                    
                })
                .catch((err) => {      
                    switch (err.error) {
                        case 'No error!':                            
                            setPageError('updated');            
                            break;
                        case 'Error with service':                            
                            setPageError('error');            
                            break;                        
                    }
                }).finally(() => {
                    setIsUpdating(false);
                    getBillingDelivery();
               });
            }else{
                setPageError({});
            }
        },
        [authHeader, emailData, saveEmailData, isEmail]
    );

    const overrides = {

        errorMsg: {
            visible: !_.isUndefined(pageError),
            content: translator(messages[pageError])
        },
        emailAddressTable: {
            data: emailData
        },
        deliveryMethod: {
            onValueChange: onClickToggleChange,
            disabled: !isEditing
        },
        billingEmailContainer: {
            visible: isEmail
        },
        billingMailContainer: {
            visible: !isEmail
        },
        cancelButton: {
            visible: isEditing
        },
        saveButton: {
            visible: isEditing,
            disabled: isAddingEmail 
        },
        addNewEmailButton : {
            visible: isEditing && !isAddingEmail
        },
        addButton: {
            visible: isEditing && !isAddingEmail
        },
        actions : {
            visible: isEditing
        },
        editButton : {
            visible: !isEditing,
            disabled: isUpdating 
        }
    };

    const resolvers = {
        resolveClassNameMap: styles, 
        resolveValue: readValue,
        resolveComponentMap: {

        },
        resolveCallbackMap: {
            enterEditMode,
            handleCancel,
            deleteDataRow,
            saveDataRow,
            addDataRow,
            handleSubmit
        },
    };    

    if (isLoading) {
        return <Loader />;
    }

    //return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );

}

export default withRouter(withAuthenticationContext(RIBillingDeliveryComponent));
